import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3 bg-gray-06" }
const _hoisted_2 = { class: "p-3 bg-white text-14 text-center" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-primary py-2 text-right" }, "\n          キャンセルについて\n        ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "pt-3 px-3 pb-2" }
const _hoisted_7 = {
  key: 0,
  class: "p-3 bg-white text-14 text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "p-3 bg-white text-14 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, "\n        勤務予定件数: " + _toDisplayString(_ctx.appliedApplicationCount) + "件\n      ", 1),
      _createTextVNode(),
      _createElementVNode("a", {
        href: _ctx.externalLink.cancel,
        class: "mb-3"
      }, _hoisted_5, 8, _hoisted_3)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedApplications, (application) => {
        return (_openBlock(), _createBlock(_component_ApplicationCard, {
          key: application.id,
          application: application,
          class: "mb-2",
          onClick: ($event: any) => (_ctx.$emit('clickOrderCard', application.id))
        }, null, 8, ["application", "onClick"]))
      }), 128)),
      _createTextVNode(),
      (_ctx.appliedApplicationCount === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "\n        お仕事はありません\n      "))
        : (_openBlock(), _createElementBlock("p", _hoisted_8, "\n        ここが最後です\n      "))
    ])
  ]))
}